import React from 'react'
import { Text } from '@/components/atoms/Text'
import { Tag, TagWithIcon } from '@/components/atoms/Tag'
import './CaseStudyCardV2.css'

export interface CaseStudyTag {
  label: string
  iconUrl?: string
  iconAlt?: string
}

export interface CaseStudyCardV2Props {
  logoUrl?: string
  logoAlt?: string
  companyName: string
  headline: string
  imageUrl?: string
  imageAlt?: string
  tags: CaseStudyTag[]
  achievements: string[]
  className?: string
}

export const CaseStudyCardV2: React.FC<CaseStudyCardV2Props> = ({
  logoUrl,
  logoAlt,
  companyName,
  headline,
  imageUrl,
  imageAlt,
  tags,
  achievements,
  className = '',
}) => {
  return (
    <div className={`case-study-card-v2 ${className}`}>
      <div className="case-study-card-v2-header">
        <div className="case-study-card-v2-company">
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={logoAlt || `${companyName} logo`}
              className="case-study-card-v2-logo"
            />
          ) : (
            <div className="case-study-card-v2-logo-placeholder" />
          )}
          <Text size="large" color="primary" weight="normal" className="case-study-card-v2-name">
            {companyName}
          </Text>
        </div>
        <Text size="large" color="primary" weight="bold" className="case-study-card-v2-headline">
          {headline}
        </Text>
      </div>

      <div className="case-study-card-v2-content">
        {imageUrl ? (
          <div className="case-study-card-v2-image-container">
            <img
              src={imageUrl}
              alt={imageAlt || `${companyName} case study`}
              className="case-study-card-v2-image"
            />
          </div>
        ) : (
          <div className="case-study-card-v2-image-placeholder" />
        )}

        <div className="case-study-card-v2-details">
          <div className="case-study-card-v2-tags">
            {tags.map((tag, index) =>
              tag.iconUrl ? (
                <TagWithIcon
                  key={index}
                  label={tag.label}
                  iconUrl={tag.iconUrl}
                  iconAlt={tag.iconAlt}
                />
              ) : (
                <Tag key={index} label={tag.label} />
              )
            )}
          </div>

          <ul className="case-study-card-v2-achievements">
            {achievements.map((achievement, index) => (
              <li key={index} className="case-study-card-v2-achievement-item">
                <Text size="large" color="primary" weight="normal">
                  {achievement}
                </Text>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}
